import gql from 'graphql-tag'

export interface IMedia {
  id: number
  url: string
}

export const MediaFieldsFragment = gql`
  fragment MediaFields on Media {
    id
    url
  }
`
